import { render, staticRenderFns } from "./BadgeIndicator.vue?vue&type=template&id=739d813f&scoped=true&"
import script from "./BadgeIndicator.vue?vue&type=script&lang=js&"
export * from "./BadgeIndicator.vue?vue&type=script&lang=js&"
import style0 from "./BadgeIndicator.vue?vue&type=style&index=0&id=739d813f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739d813f",
  null
  
)

export default component.exports